import { Point } from "pixi.js";

/** Converts DOMPoint[] to PIXI.Point[]. */
export function domPointsToPixiPoints(points: DOMPoint[]) {
  return points.map(({ x, y }) => new Point(x, y));
}
